import { EVWriteBackStatus } from "../../../../enums/evBvWriteBackStatus";
import EyeIcon from "../../../../svg/eye";
import { InfoIcon } from "../../../../svg/info-icon";
import { RedCrossIcon } from "../../../../svg/red-cross-icon";
import RefreshIcon from "../../../../svg/refresh-icon";
import TickWithWavyCircle from "../../../../svg/tickWithWavyCircle";

interface RpaStatusCardProps {
  status?: string;
  handleIconClick?: () => void;
}
const RpaStatusCard = (props: RpaStatusCardProps) => {
  const getIconBasedOnStatus = () => {
    if (props.status === EVWriteBackStatus.SUCCESS) {
      return <TickWithWavyCircle width="16" height="16" fillColor="#008367" />;
    } else if (props.status === EVWriteBackStatus.ERROR) {
      return <RedCrossIcon height="16" width="16" />;
    } else if (props.status === EVWriteBackStatus.IN_PROGRESS) {
      return (
        <InfoIcon height="16" width="16" stroke="#0056d6" strokeWidth="1.4" />
      );
    }
  };

  const getStatusText = () => {
    if (props.status === EVWriteBackStatus.SUCCESS) {
      return "Comment RPA was successfull";
    } else if (props.status === EVWriteBackStatus.ERROR) {
      return "Comment RPA was failed";
    } else if (props.status === EVWriteBackStatus.IN_PROGRESS) {
      return "Comment RPA is in progress";
    }
  };

  const shoulsShowEndIcon = () => {
    if (
      props.status === EVWriteBackStatus.SUCCESS ||
      props.status === EVWriteBackStatus.ERROR
    ) {
      return true;
    } else {
      return false;
    }
  };

  const determineEndIcon = () => {
    if (props.status === EVWriteBackStatus.SUCCESS) {
      return <EyeIcon />;
    } else if (props.status === EVWriteBackStatus.ERROR) {
      return <RefreshIcon height="16" width="16" fill="#0056d6" />;
    }
  };
  return (
    <div className="rpa-status-card flex items-center gap-2 rounded-md bg-primaryGray-16 p-2">
      <div className="rpa-status--icon">{getIconBasedOnStatus()}</div>
      <div className="rpa-status--text text-xs text-primaryGray-1">
        {getStatusText()}
      </div>
      {shoulsShowEndIcon() && (
        <div
          className="rpa-status--end-icon cursor-pointer border-l-2 border-primaryGray-13 pl-2 hover:scale-105"
          onClick={() => {
            props?.handleIconClick?.();
          }}
        >
          {determineEndIcon()}
        </div>
      )}
    </div>
  );
};

export default RpaStatusCard;
